var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-footer', {
    attrs: {
      "color": "#FFF"
    }
  }, [_c('div', {
    staticClass: "footer_container"
  }, [_c('div', {
    staticClass: "powered_by"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('img', {
    attrs: {
      "src": _vm.img
    }
  }), _c('h4', [_vm._v("Avalanche Explorer")])]), _c('p', {
    staticClass: "avalanche_desc"
  }, [_vm._v(" Avalanche Explorer is an analytics tool that enables people to search the Avalanche blockchain for transactions, addresses, and other platform activities. ")]), _c('p', {
    staticClass: "avalanche_desc tos"
  }, [_vm._v(" By using this application you agree to the "), _c('a', {
    attrs: {
      "href": "/Avalanche (BVI) Inc. Explorer Terms of Use.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Terms of Use")]), _vm._v(". ")])]), _c('div', {
    staticClass: "lists"
  }, [_c('div', {
    staticClass: "list"
  }, [_c('h4', [_vm._v("Menu")]), _c('a', {
    attrs: {
      "href": _vm.cChainURL
    }
  }, [_vm._v("Home")]), _c('router-link', {
    attrs: {
      "to": "/subnets"
    }
  }, [_vm._v("Subnets")]), _c('router-link', {
    attrs: {
      "to": "/validators"
    }
  }, [_vm._v("Validators")]), _c('router-link', {
    attrs: {
      "to": "/assets"
    }
  }, [_vm._v("Assets")]), _c('router-link', {
    attrs: {
      "to": "/blockchains"
    }
  }, [_vm._v("Blockchains")]), _c('a', {
    attrs: {
      "href": _vm.cChainURL
    }
  }, [_vm._v("C-Chain")]), _c('a', {
    attrs: {
      "href": _vm.statusPageURL
    }
  }, [_vm._v("Status")]), _c('router-link', {
    attrs: {
      "to": "/resources"
    }
  }, [_vm._v("Resources")])], 1), _c('div', {
    staticClass: "list"
  }, [_c('h4', [_vm._v("Social")]), _c('a', {
    attrs: {
      "href": "https://twitter.com/avalancheavax",
      "target": "_blank"
    }
  }, [_c('fa', {
    attrs: {
      "icon": ['fab', 'twitter']
    }
  }), _vm._v("Twitter ")], 1), _c('a', {
    attrs: {
      "href": "https://chat.avax.network",
      "target": "_blank"
    }
  }, [_c('fa', {
    attrs: {
      "icon": ['fab', 'discord']
    }
  }), _vm._v("Discord ")], 1), _c('a', {
    attrs: {
      "href": "https://reddit.com/r/avax",
      "target": "_blank"
    }
  }, [_c('fa', {
    attrs: {
      "icon": ['fab', 'reddit']
    }
  }), _vm._v("Reddit ")], 1), _c('a', {
    attrs: {
      "href": "https://github.com/ava-labs/avalanche-explorer",
      "target": "_blank"
    }
  }, [_c('fa', {
    attrs: {
      "icon": ['fab', 'github']
    }
  }), _vm._v("GitHub ")], 1)])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }